import React, { useState } from "react";
import DataTable from "../UI/table/DataTable";
import { useQuery } from "react-query";
import {
  deleteGovernrotes,
  getGovernorates,
  updateGovernatores,
} from "../../MyApi/admin/governorates";
import StatusBadge from "../UI/statusBadge";
import TableActions from "../UI/table/TableActions";
import AddGovernorateModal from "./storemodals/governatiosmodal";
import i18next from "i18next";

const GovernoratesComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState("");

  const lang = i18next.language;

  const { data, isLoading, refetch } = useQuery(
    ["governorates-data", lang],
    () => getGovernorates("", lang),
  );

  const governoratesColumns = [
    { label: "اسم المحافظة", accessor: "name" },
         { label: "الدولة", accessor: "country.name" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => openModal("edit", row.id)}
          deleteFn={deleteGovernrotes}
          refetch={refetch}
          mutationKey={"deleteGovernrotes"}
          id={row.id}
          editPermission="update_governorate"
          deletePermission="delete_governorate"
          togglePermission="update_governorate"
          toggleMutationKey={"toggle-update-governorate"}
          toggleFn={(id, status) => updateGovernatores({is_active: status, "_method": "PUT", lang: i18next.language}, i18next.language, id)}
          is_active={row.is_active}
        />
      ),
    },
  ];

  const systemData = data?.data?.governorates || [];

  const openModal = (mode, id) => {
    setShowModal(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMode("add");
    setModalId("");
  };

  return (
    <>
      <DataTable
        actionLabel="إضافة المحافظات"
        createPermission="create_governorate"
        onAddClick={() => openModal("add")}
        title="المحافظات"
        columns={governoratesColumns}
        data={systemData}
        isLoading={isLoading}
      />
      {showModal && (
        <AddGovernorateModal
          show={showModal}
          onClose={closeModal}
          refetch={refetch}
          modalMode={modalMode}
          modalId={modalId}
        />
      )}
    </>
  );
};

export default GovernoratesComponent;
